// @ts-nocheck
import { memo } from 'react'

import Svg, { G, Path, Defs, Mask, LinearGradient, Stop } from 'react-native-svg'

type IdentityCardIllustrationProps = {
  width?: number
  height?: number
}

const IdentityCardIllustration = ({ width = 154, height = 244 }: IdentityCardIllustrationProps) => (
  <Svg width={width} height={height} viewBox="0 0 154 244" fill="none">
    <Mask
      id="identity-card-a"
      width={154}
      height={244}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance'
      }}>
      <Path fill="#fff" d="M153.07 243.78V0H0v243.78h153.07Z" />
    </Mask>
    <G mask="url(#identity-card-a)">
      <Path fill="#fff" d="M167.34 248.7V-3.28H-14.28V248.7h181.62Z" />
      <Path
        fill="url(#identity-card-b)"
        d="M154.8-31.707 92.63-93.876c-8.891-8.892-23.309-8.892-32.2 0l-62.17 62.17c-8.892 8.891-8.892 23.309 0 32.2l62.17 62.17c8.891 8.892 23.309 8.892 32.2 0L154.8.494c8.892-8.891 8.892-23.309 0-32.2Z"
      />
      <Path
        fill="url(#identity-card-c)"
        d="m180.374-81.137-88.48-88.48c-8.49-8.49-22.255-8.49-30.745 0l-88.48 88.48c-8.49 8.49-8.49 22.255 0 30.745l88.48 88.48c8.49 8.49 22.255 8.49 30.745 0l88.48-88.48c8.49-8.49 8.49-22.255 0-30.745Z"
      />
      <Path
        fill="url(#identity-card-d)"
        d="M-9.37 119.898 190.762-80.235l-46.245-46.244L-55.615 73.653l46.245 46.245Z"
        style={{
          mixBlendMode: 'multiply'
        }}
      />
      <Path
        fill="url(#identity-card-e)"
        d="m201.596-23.23-23.624-23.625L80.73 50.387l23.625 23.624 97.241-97.241Z"
        style={{
          mixBlendMode: 'multiply'
        }}
      />
      <Path
        fill="url(#identity-card-f)"
        d="M184.821 6.117 171.796-6.908 74.555 90.334l13.025 13.025L184.82 6.117Z"
        style={{
          mixBlendMode: 'multiply'
        }}
      />
      <Path
        fill="url(#identity-card-g)"
        d="m-14.283 253.744 13.024 13.025 97.242-97.242-13.025-13.025-97.241 97.242Z"
        style={{
          mixBlendMode: 'multiply'
        }}
      />
      <Path
        fill="url(#identity-card-h)"
        d="m-60.926 106.29 35.044 35.044 97.241-97.241L36.315 9.049l-97.242 97.241Z"
        style={{
          mixBlendMode: 'multiply'
        }}
      />
      <Path
        fill="url(#identity-card-i)"
        d="m201.224 120.872-16.759-16.758-125.13 125.13 16.76 16.758 125.129-125.13Z"
        style={{
          mixBlendMode: 'multiply'
        }}
      />
      <Path
        fill="url(#identity-card-j)"
        d="m58.409 267.442 11.314 11.314 84.457-84.457-11.314-11.314-84.457 84.457Z"
        style={{
          mixBlendMode: 'multiply'
        }}
      />
    </G>
    <Defs>
      <LinearGradient
        id="identity-card-b"
        x1={76.524}
        x2={76.524}
        y1={89.996}
        y2={-44.424}
        gradientUnits="userSpaceOnUse">
        <Stop offset={0.28} stopColor="#141414" />
        <Stop offset={1} />
      </LinearGradient>
      <LinearGradient
        id="identity-card-c"
        x1={76.523}
        x2={76.523}
        y1={-175.98}
        y2={44.46}
        gradientUnits="userSpaceOnUse">
        <Stop offset={0.28} stopColor="#E41513" />
        <Stop offset={1} stopColor="#CC1517" />
      </LinearGradient>
      <LinearGradient
        id="identity-card-d"
        x1={41.257}
        x2={89.471}
        y1={-29.628}
        y2={18.585}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#CAC9C9" />
        <Stop offset={0.04} stopColor="#CDCCCC" />
        <Stop offset={0.42} stopColor="#E8E8E8" />
        <Stop offset={0.75} stopColor="#F9F9F9" />
        <Stop offset={1} stopColor="#fff" />
      </LinearGradient>
      <LinearGradient
        id="identity-card-e"
        x1={200.649}
        x2={130.136}
        y1={-45.9}
        y2={24.613}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#CAC9C9" />
        <Stop offset={0.04} stopColor="#CDCCCC" />
        <Stop offset={0.42} stopColor="#E8E8E8" />
        <Stop offset={0.75} stopColor="#F9F9F9" />
        <Stop offset={1} stopColor="#fff" />
      </LinearGradient>
      <LinearGradient
        id="identity-card-f"
        x1={186.766}
        x2={116.246}
        y1={-13.674}
        y2={56.846}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#CAC9C9" />
        <Stop offset={0.04} stopColor="#CDCCCC" />
        <Stop offset={0.42} stopColor="#E8E8E8" />
        <Stop offset={0.75} stopColor="#F9F9F9" />
        <Stop offset={1} stopColor="#fff" />
      </LinearGradient>
      <LinearGradient
        id="identity-card-g"
        x1={-23.474}
        x2={47.045}
        y1={266.275}
        y2={195.755}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#CAC9C9" />
        <Stop offset={0.04} stopColor="#CDCCCC" />
        <Stop offset={0.42} stopColor="#E8E8E8" />
        <Stop offset={0.75} stopColor="#F9F9F9" />
        <Stop offset={1} stopColor="#fff" />
      </LinearGradient>
      <LinearGradient
        id="identity-card-h"
        x1={-60.849}
        x2={9.67}
        y1={128.09}
        y2={57.57}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#CAC9C9" />
        <Stop offset={0.04} stopColor="#CDCCCC" />
        <Stop offset={0.42} stopColor="#E8E8E8" />
        <Stop offset={0.75} stopColor="#F9F9F9" />
        <Stop offset={1} stopColor="#fff" />
      </LinearGradient>
      <LinearGradient
        id="identity-card-i"
        x1={204.269}
        x2={113.533}
        y1={95.959}
        y2={186.695}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#CAC9C9" />
        <Stop offset={0.04} stopColor="#CDCCCC" />
        <Stop offset={0.42} stopColor="#E8E8E8" />
        <Stop offset={0.75} stopColor="#F9F9F9" />
        <Stop offset={1} stopColor="#fff" />
      </LinearGradient>
      <LinearGradient
        id="identity-card-j"
        x1={49.794}
        x2={111.037}
        y1={277.665}
        y2={216.422}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#CAC9C9" />
        <Stop offset={0.04} stopColor="#CDCCCC" />
        <Stop offset={0.42} stopColor="#E8E8E8" />
        <Stop offset={0.75} stopColor="#F9F9F9" />
        <Stop offset={1} stopColor="#fff" />
      </LinearGradient>
    </Defs>
  </Svg>
)

export const IdentityCard = memo(IdentityCardIllustration)
